<template>
<div id="profile-settings-container">
    
    <div class="container card p-5 shadow w-100">
        <h1>{{$t('PROFILE_INFO')}}</h1>
        <hr>
            <div class="tab-content profile-tab mb-4" id="myTabContent">
                <h4 class='mb-5'>{{doctorProfile.firstName}} {{doctorProfile.lastName}}</h4>
                
                <div class="tab-pane fade show active" id="profileList" role="tabpanel" aria-labelledby="home-tab">
                    <div class="row py-2">
                        <div class="col-md-6">
                            <label>{{$t('EMAIL')}}</label>
                        </div>
                        <div class="col-md-6">
                            <p>{{doctorProfile.email}}</p>
                        </div>
                    </div>
                    <div class="row py-2">
                        <div class="col-md-6">
                            <label>{{$t('RIZIV')}}</label>
                        </div>
                        <div class="col-md-6">
                            <p>{{doctorProfile.riziv}}</p>
                        </div>
                    </div>
                    <div class="row py-2">
                        <div class="col-md-6">
                            <label>{{$t('PHONE_NUMBER')}}</label>
                        </div>
                        <div class="col-md-6">
                            <p>{{doctorProfile.phoneNumber}}</p>
                        </div>
                    </div>
                    <div class="row py-2">
                        <div class="col-md-6">
                            <label>{{$t('CITY')}}</label>
                        </div>
                        <div class="col-md-6">
                            <p>{{doctorProfile.city}}</p>
                        </div>
                    </div>
                    <div class="row py-2">
                        <div class="col-md-6">
                            <label>{{$t('ADDRESS')}}</label>
                        </div>
                        <div class="col-md-6">
                            <p>{{doctorProfile.address}}</p>
                        </div>
                    </div>
                    <div class="row py-2">
                        <div class="col-md-6">
                            <label>{{$t('POSTCODE')}}</label>
                        </div>
                        <div class="col-md-6">
                            <p>{{doctorProfile.postcode}}</p>
                        </div>
                    </div>
                    <div class="row py-2">
                        <div class="col-md-6">
                            <label>{{$t('DEFAULT_LANGUAGE')}}</label>
                        </div>
                        <div class="col-md-6">
                            <span class="mr-2">{{doctorProfile.language.longTitle}}</span>
                            <img class="img-profile rounded-circle" :src="doctorProfile.language.flagImagePath">
                            
                        </div>
                    </div>
                </div>
            </div>
        
        <button type="button" class="btn btn-primary mb-3 col-md-4" @click='$router.push("/admin/profile/settings")'>{{$t('EDIT_PROFILE')}}</button>
        
    </div>
</div>
</template>
<script>
export default {
    data() {
        return {
            doctorProfile :
            {
                "firstName": "",
                "lastName": "",
                "email": "",
                "riziv": "",
                "phoneNumber": "",
                "city": "",
                "postcode": "",
                "address": "",
                "language":
                {
                    "title": null,
                    "longTitle": null,
                    "flagImagePath": null,
                    "translationsPath": null
                }
            }
        }
    },
    methods: {
        getDoctorInformation: function(doctorId){
            let self = this;
            this.$http.get("/api/doctor/profile")
                .then(response =>
                {
                    self.doctorProfile = response.data;
                })
                .catch();
        }
    },
    created: function () {
        this.getDoctorInformation()
    }
}
</script>
<style lang="scss" scoped>
.profile-tab{
    label{
        font-weight: 600;
        vertical-align: middle;
        display: table-cell;
    }
    p{
        font-weight: 600;
        color: #428bca;
        vertical-align: middle;
        display: table-cell;
    }
    span{
        font-weight: 600;
        color: #428bca;
        vertical-align: middle;
    }
    
    h4{
        font-weight: 600;
        color: #428bca;
    }
    #profileList{
        .row:nth-child(even){
            background-color: whitesmoke;
        }
    }
    
}
.rounded-circle {
            height : 1.8rem;
            width : 1.8rem;
        }


</style>

